<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-12">
          <!-- Recent Order Table -->
          <div class="card card-table-border-none" id="recent-orders">
            <div class="card-header justify-content-between">
              <h2>{{ $t("sidebar.myProductsInSales") }}</h2>
            </div>
            <div class=" card-body card-body-white pt-0 pb-5">
              <v-table
                :data="products"
                :currentPage.sync="currentPage"
                :pageSize="10"
                @totalPagesChanged="totalPages = $event"
                class="table card-table table-responsive-xs table-responsive-sm table-responsive-large table-striped"
                style="width:100%"
              >
                <thead slot="head">
                  <th class="d-none d-md-table-cell text-center">
                    {{ $t("ecommerce.product.name") }}
                  </th>
                  <th class="d-none d-md-table-cell text-center">
                    {{ $t("attr.pictures") }}
                  </th>
                  <th class="d-none d-md-table-cell text-center">
                    {{ $t("ecommerce.product.quantity") }}
                  </th>
                  <th class="d-none d-md-table-cell text-center">
                    {{ $t("sentence.timeLeft") }}
                  </th>
                  <th class="d-none d-md-table-cell text-center">
                    {{ $t("ecommerce.product.price") }}
                  </th>
                  <th class="d-none d-md-table-cell text-center">
                    {{ $t("sentence.highestOffer") }}
                  </th>
                  <th class="d-none d-md-table-cell text-center">
                    {{ $t("sentence.highestBids") }}
                  </th>
                  <th class="d-none d-md-table-cell text-center">
                    {{ $t("main.action") }}
                  </th>
                </thead>
                <tbody slot="body" slot-scope="{ displayData }">
                  <tr v-for="product in displayData" :key="product.id">
                    <td class="text-center">
                      <a class="text-dark" href=""> {{ product.name }}</a>
                    </td>
                    <td class="d-none d-md-table-cell text-center">
                      <img
                        :src="
                          Array.isArray(product.pictures)
                            ? storageUrl + product.pictures[0]
                            : storageUrl + product.pictures
                        "
                        class="thumbnail"
                      />
                    </td>
                    <td class="d-none d-md-table-cell text-center">
                      {{ product.quantity }}
                    </td>
                    <td
                      v-if="product.sales_type == 'auction'"
                      class="d-none d-md-table-cell text-center"
                    >
                      <TimerSimple
                        :deadline="product.validated"
                        :duration="product.duration"
                      />
                    </td>
                    <td v-else>
                      {{ $t("sentence.noDeadline") }}
                    </td>
                    <td v-if="product.sales_type == 'auction'">
                      {{ $t("ecommerce.product.startingFrom") }}
                      {{
                        product.starting_price
                          | currency(" DA", 0, { symbolOnLeft: false })
                      }}
                    </td>
                    <td v-else>
                      {{
                        product.fixed_price
                          | currency(" DA", 0, { symbolOnLeft: false })
                      }}
                    </td>
                    <td class="text-center">
                      <a
                        v-if="product.offers.length > 0"
                        href="#"
                        class="btn btn-outline-default"
                      >
                        {{
                          product.offers[product.offers.length - 1].price
                            | currency(" DA", 0, { symbolOnLeft: false })
                        }}
                      </a>
                      <span v-else>{{
                        $t("sentence.noActionForThisProduct", {
                          action: $t("ecommerce.offers"),
                        })
                      }}</span>
                    </td>
                    <td
                      v-if="product.sales_type == 'auction'"
                      class="text-center"
                    >
                      <a
                        v-if="product.bids.length > 0"
                        href="#"
                        class="btn btn-outline-default"
                      >
                        {{
                          product.bids[product.bids.length - 1].price
                            | currency(" DA", 0, { symbolOnLeft: false })
                        }}
                      </a>
                      <span v-else>{{
                        $t("sentence.noActionForThisProduct", {
                          action: $t("ecommerce.bids"),
                        })
                      }}</span>
                    </td>
                    <td class="text-center" v-else>-</td>
                    <td class="text-center">
                      <router-link
                        v-if="
                          product.sales_type === 'auction' &&
                            product.auction_status === 0 &&
                            !productSelled(product)
                        "
                        class="btn btn-outline-default"
                        :to="{
                          name: 'resellProduct',
                          params: {
                            id: product.id,
                          },
                        }"
                        >{{ $t("sentence.relistProduct") }}</router-link
                      >
                      <a
                        v-else
                        @click="showProductDetails(product.id)"
                        class="btn btn-outline-default"
                      >
                        {{ $t("sentence.seeMore") }}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <smart-pagination
                :currentPage.sync="currentPage"
                :totalPages="totalPages"
              />
            </div>
          </div>

          <!-- Selected Product details -->
          <div class="product-details"></div>
          <div
            v-if="selectedProduct !== null"
            class="card card-white card-table-border-none"
            id="product-details"
          >
            <div class="card-header justify-content-between">
              <h2>{{ $t("ecommerce.product.details") }}</h2>
            </div>
            <div class="card-body card-body-white pt-0 pb-5">
              <div class="row" style="margin-top:5%;">
                <div class="col-4 image-preview text-center">
                  <img
                    class="thumbnail"
                    v-if="
                      undefined !== selectedProduct.pictures &&
                        selectedProduct.pictures.length > 0
                    "
                    :src="
                      Array.isArray(selectedProduct.pictures)
                        ? storageUrl + selectedProduct.pictures[0]
                        : storageUrl + selectedProduct.pictures
                    "
                  />
                  <h4>{{ selectedProduct.name }}</h4>
                </div>
                <div
                  class="col-6 text-center"
                  v-if="
                    selectedProduct.sales_type == 'auction' &&
                      deadlineReached(selectedProduct) !== false
                  "
                >
                  <h4>{{ $t("sentence.timeLeft") }}</h4>
                  <Timer
                    :deadline="selectedProduct.validated"
                    :duration="selectedProduct.duration"
                    style="margin-top:3%;"
                  />
                </div>
                <div
                  v-else-if="
                    selectedProduct.sales_type == 'auction' &&
                      deadlineReached(selectedProduct) == false
                  "
                  class="col text-center"
                >
                  <div
                    v-if="selectedProduct.validated === null"
                    class="alert alert-info"
                  >
                    {{ $t("api.product_not_validated_yet") }}
                  </div>
                  <div
                    v-else-if="
                      selectedProduct.bids.length == 0 &&
                        selectedProduct.offers.length == 0
                    "
                    class="alert alert-info"
                  >
                    {{ $t("sentence.auctionEnded") }}
                    {{ $t("sentence.productDidntReceiveAnOffer") }}
                  </div>
                  <div class="alert alert-info" v-else>
                    {{ $t("sentence.auctionEnded") }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div
                    class="sales-details table-responsive-xs table-responsive-sm"
                  >
                    <table
                      class="table card-table table-responsive table-responsive-large"
                    >
                      <tbody>
                        <tr>
                          <td>{{ $t("ecommerce.sales-type") }} :</td>
                          <td v-if="selectedProduct.sales_type == 'auction'">
                            {{ $t("ecommerce.bids") }}
                          </td>
                          <td v-else>{{ $t("ecommerce.fixed-price") }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t("ecommerce.product.acceptOffers") }} :</td>
                          <td v-if="selectedProduct.accept_offer">
                            {{ $t("general.yes") }}
                          </td>
                          <td v-else>{{ $t("general.no") }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t("ecommerce.product.buy-it-now") }}</td>
                          <td v-if="selectedProduct.buy_it_now_price == null">
                            {{ $t("general.notFixed") }}
                          </td>
                          <td v-else>
                            {{
                              selectedProduct.buy_it_now_price
                                | currency(" DA", 0, { symbolOnLeft: false })
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("ecommerce.product.lowest-price") }}</td>
                          <td v-if="selectedProduct.lowest_price == null">
                            {{ $t("general.notFixed") }}
                          </td>
                          <td v-else>
                            {{
                              selectedProduct.lowest_price
                                | currency(" DA", 0, { symbolOnLeft: false })
                            }}
                          </td>
                        </tr>
                        <tr v-if="selectedProduct.sales_type == 'auction'">
                          <td>{{ $t("ecommerce.product.startingFrom") }}</td>
                          <td>
                            {{
                              selectedProduct.starting_price
                                | currency(" DA", 0, { symbolOnLeft: false })
                            }}
                          </td>
                        </tr>
                        <tr v-else>
                          <td>{{ $t("ecommerce.fixed-price") }}</td>
                          <td>
                            {{
                              selectedProduct.fixed_price
                                | currency(" DA", 0, { symbolOnLeft: false })
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div v-if="selectedProduct.sales_type == 'auction'">
                    <div class="row" style="margin-bottom:3%;">
                      <h3>
                        {{ $t("ecommerce.auction-details") }}
                      </h3>
                    </div>
                    <div
                      v-if="deadlineReached(selectedProduct) !== false"
                      class="row"
                    >
                      <table v-if="selectedProduct.bids.length > 0">
                        <tbody>
                          <tr>
                            <td>{{ $t("sentence.numberOfBids") }} :</td>
                            <td style="text-align: right">
                              {{ selectedProduct.bids.length }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("sentence.highestBids") }} :</td>
                            <td>
                              {{
                                selectedProduct.bids[
                                  selectedProduct.bids.length - 1
                                ].price
                                  | currency(" DA", 0, { symbolOnLeft: false })
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                      v-else-if="meetRequirement(selectedProduct) !== false"
                      class="row"
                    >
                      <label>
                        {{ $t("ecommerce.auction-winner") }} :
                        {{
                          selectedProduct.bids[selectedProduct.bids.length - 1]
                            .price
                            | currency(" DA", 0, { symbolOnLeft: false })
                        }}

                        <!-- Link to bid information (user ..etc) -->
                      </label>
                    </div>
                    <div v-else class="text-center alert alert-info">
                      <label>{{
                        $t("sentence.noActionForThisProductHasBeenSent", {
                          action: $t("ecommerce.bids"),
                        })
                      }}</label>
                    </div>
                  </div>
                  <div class="row" v-if="selectedProduct.accept_offer == true">
                    <h3
                      v-if="
                        selectedProduct.offers.length > 0 &&
                          productHasAcceptedOffer.length == 0
                      "
                    >
                      {{ $t("ecommerce.offer-list") }}
                    </h3>

                    <v-table
                      class="table card-table table-responsive table-responsive-large table-striped"
                      :data="selectedProduct.offers"
                      :currentPage.sync="currentPageOffers"
                      :pageSize="5"
                      @totalPagesChanged="totalPagesOffers = $event"
                      v-if="
                        selectedProduct.offers.length > 0 &&
                          productHasAcceptedOffer.length == 0
                      "
                    >
                      <thead slot="head">
                        <th class="text-center">{{ $t("action.offered") }}</th>
                        <th class="text-center">{{ $t("main.action") }}</th>
                      </thead>
                      <tbody slot="body">
                        <tr
                          v-for="offer in selectedProduct.offers"
                          v-bind:key="offer.id"
                        >
                          <td class="text-center">
                            {{
                              offer.price
                                | currency(" DA", 0, { symbolOnLeft: false })
                            }}
                          </td>
                          <td class="text-center" v-if="offer.status == null">
                            <a
                              @click="respondOffer(offer.id, true)"
                              class="btn btn-success btn-pill color-white"
                              style="margin-right:2%;"
                              ><i class="mdi mdi-check"></i>
                              {{ $t("action.accept") }}</a
                            >
                            <a
                              @click="respondOffer(offer.id, false)"
                              class="btn btn-danger btn-pill color-white"
                              ><i class="mdi mdi-close"></i>
                              {{ $t("action.refuse") }}</a
                            >
                          </td>
                          <td class="text-center" v-else>
                            <span
                              v-if="offer.status == true"
                              class="color-green"
                            >
                              <i class="mdi mdi-check"></i>
                              {{ $t("action.accepted") }}
                            </span>

                            <span v-else class="color-red">
                              <i class="mdi mdi-close"></i>
                              {{ $t("action.refused") }}</span
                            >
                          </td>
                        </tr>
                      </tbody></v-table
                    >

                    <div
                      style="margin-top: 10%;"
                      v-else-if="productHasAcceptedOffer.length > 0"
                    >
                      <h3>
                        {{ $t("ecommerce.product.acceptedOffers") }} :
                        {{
                          productHasAcceptedOffer[0]
                            | currency(" DA", 0, { symbolOnLeft: false })
                        }}
                        DA
                      </h3>
                      <div class="alert alert-warning" style="margin-top: 5%;">
                        {{ $t("sentence.waitingClientConfirmation") }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="alert alert-danger"
                      style="margin-top:30%;"
                    >
                      {{ $t("ecommerce.no-offer") }}
                    </div>
                    <smart-pagination
                      v-if="
                        selectedProduct.offers.length > 0 &&
                          productHasAcceptedOffer.length == 0
                      "
                      :currentPage.sync="currentPageOffers"
                      :totalPages="totalPagesOffers"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimerSimple from "@/components/templates/TimerSimple";
import config from "@/config";
import Timer from "@/components/templates/Timer";
import moment from "moment";

export default {
  mounted() {
    this.getUserProducts();
  },
  components: {
    TimerSimple,
    Timer,
  },
  data() {
    return {
      products: [],
      success: false,
      storageUrl: config.storageUrl,
      selectedProduct: null,
      currentPage: 1,
      totalPages: 0,

      currentPageOffers: 1,
      totalPagesOffers: 0,
      currentPageBids: 1,
      totalPagesBids: 0,
    };
  },
  methods: {
    getUserProducts() {
      var self = this;
      this.$axios({
        url: "user/products",
        method: "GET",
      })
        .then((response) => {
          self.products = response.data;
        })
        .catch(function() {
          
        });
    },

    showProductDetails(id) {
      var self = this;

      this.$axios({
        url: "product/get/" + id,
        method: "GET",
      })
        .then((response) => {
          self.selectedProduct = response.data;
          self.scrollToClass("product-details");
        })
        .catch(function() {
          
        });
    },
    scrollToClass(className) {
      var el = this.$el.getElementsByClassName(className)[0];
      el.scrollIntoView({ behavior: "smooth" });
    },
    respondOffer(id, response) {
      var self = this;

      this.$axios({
        url: "offers/respond/" + id,
        method: "POST",
        data: { response: response },
      })
        .then((response) => {
          self.selectedProduct = response.data[0];
        })
        .catch(function() {
        });
      // Todo accept offer ==> display offer with accepted offer and status (waiting for client confirmation/payment ..etc)
    },
    deadlineReached(product) {
      var currentTime = Date.parse(product.validated) - Date.parse(new Date());
      currentTime += 1000 * 60 * 60 * 24 * product.duration;
      return currentTime > 0;
    },

    meetRequirement(product) {
      if (product.sales_type !== "auction") {
        return false;
      }

      if (product.bids.length == 0) {
        return false;
      }

      if (product.lowest_price > product.bids[product.bids.length - 1].price) {
        return false;
      }
    },
    productSelled(product) {
      if (undefined === product) return false;

      var bidsWon = product.bids.filter((b) => b.status === 1);

      if (bidsWon.length > 0) {
        let diffDays = Math.abs(
          moment(bidsWon[0].updated_at, "YYYY-MM-DD HH:mm:ss").diff(
            moment(),
            "days"
          )
        );

        if (diffDays > 15 && product.orders.length === 0) return false;

        return true;
      }

      var offerWon = product.offers.filter((o) => o.status === 1);

      if (offerWon.length > 0) {
        let diffDays = Math.abs(
          moment(offerWon[0].updated_at, "YYYY-MM-DD HH:mm:ss").diff(
            moment(),
            "days"
          )
        );

        if (diffDays > 15 && product.orders.length === 0) return false;

        return true;
      }

      return false;
    },
  },
  computed: {
    productHasAcceptedOffer() {
      if (this.selectedProduct == null) return false;
      console.log(
        this.selectedProduct.offers.filter((i) => i.status == 1).length > 0
      );
      return this.selectedProduct.offers.filter((i) => i.status == 1);
    },
  },
};
</script>

<style scoped>
.thumbnail {
  border: 1px solid var(--color-d); /* Gray border */
  border-radius: 4px; /* Rounded border */
  padding: 5px; /* Some padding */
  width: 150px; /* Set a small width */
}

/* Add a hover effect (blue shadow) */
.thumbnail:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}

.countdownv2_holder {
  bottom: 50% !important;
}

.countdownv2_holder .countdownv2 {
  width: 100% !important;
}

.card-white {
  background-color: white !important;
}

.card-body-white {
  background-color: white !important;
}

.pagination {
  display: flex;
  justify-content: center;
}
.color-green {
  color: green;
}

.color-red {
  color: red;
}
</style>
